import Service from './Service';
import { isAfter, isEqual, parse } from 'date-fns';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class BeneficiarioService extends Service {
  async consultarNomes () {
    let nomes = [];
    let result = await this.getBeneficiarioApi().consultarNomes();
    nomes = result;

    return nomes;
  }
  async consultarFluxo (filter) {
    let beneficiarios = [];
    let result = await this.getBeneficiarioApi().consultarFluxo(filter);
    beneficiarios = result;

    return beneficiarios;
  }
  async consultarBeneficiarios (filtro) {
    let beneficiarios = [];
    const bolCarteira = /^([0-9]{5}-[0-9]{2})$/.test(filtro);
    const bolCodigoServidor = /^([cC]?[0]?[0-9]{1,5})$/.test(filtro);
    const bolNome = /^([ \u00c0-\u01ffa-zA-Z'-])+$/.test(filtro.toUpperCase());

    const filter = {
      carteira: bolCarteira ? filtro.toUpperCase() : 'vazio',
      codServidor: bolCodigoServidor ? filtro.toUpperCase() : 'vazio',
      nome: bolNome ? filtro.toUpperCase() : 'vazio'
    };
    let result = await this.getBeneficiarioApi().consultarBeneficiarios(filter);
    beneficiarios = result || [];

    return beneficiarios;
  }
  async consultarHistoricoAdesao (filter) {
    let historicoAdesao = [];
    let result = await this.getBeneficiarioApi().consultarHistoricoAdesao(filter);
    historicoAdesao = result || [];

    return historicoAdesao;
  }
  async incluirTitular (filter) {
    let result = await this.getBeneficiarioApi().incluirTitular(filter);
    return result;
  }
  async incluirDependente (filter) {
    let result = await this.getBeneficiarioApi().incluirDependente(filter);
    return result;
  }
  async excluirTitular (filter) {
    let result = await this.getBeneficiarioApi().excluirTitular(filter);
    return result;
  }
  async exlcuirDependente (filter) {
    let result = await this.getBeneficiarioApi().exlcuirDependente(filter);
    return result;
  }
  async alterarTitularidade (filter, codTitularidade) {
    let result = await this.getBeneficiarioApi().alterarTitularidade(filter, codTitularidade);
    return result;
  }

  async consultarDependencias (filter) {
    let result = await this.getBeneficiarioApi().consultarDependencias(filter);
    return result;
  }
  async salvarDataInicial (filter, data) {
    let result = await this.getBeneficiarioApi().salvarDataInicial(filter, data);
    return result;
  }
  async salvarDataFim (filter, data) {
    let result = await this.getBeneficiarioApi().salvarDataFim(filter, data);
    return result;
  }
  async consultarLimitesDataInicioTitular (filter, data) {
    let result = await this.getBeneficiarioApi().consultarLimitesDataInicioTitular(filter, data);
    return result;
  }
  async consultarLimitesDataInicioDependente (filter) {
    let result = await this.getBeneficiarioApi().consultarLimitesDataInicioDependente(filter);
    return result;
  }
  async consultarLimitesDataFimTitular (filter, data) {
    let result = await this.getBeneficiarioApi().consultarLimitesDataFimTitular(filter, data);
    return result;
  }
  async consultarLimitesDataFimDependente (filter) {
    let result = await this.getBeneficiarioApi().consultarLimitesDataFimDependente(filter);
    return result;
  }
  async validarDataInicio (data, dataFim, titularidade, indRegistroPossuiDependencias, dataInicioOriginal, dataInicioLimiteMinimo, dataInicioLimiteMaximo) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    dataFim = dataFim === null ? dataNula : parse(parse(dataFim).setHours(0, 0, 0, 0));
    dataInicioOriginal = dataInicioOriginal === null ? dataNula : parse(parse(dataInicioOriginal).setHours(0, 0, 0, 0));
    dataInicioLimiteMinimo = dataInicioLimiteMinimo === null ? dataNula : parse(parse(dataInicioLimiteMinimo).setHours(0, 0, 0, 0));
    dataInicioLimiteMaximo = dataInicioLimiteMaximo === null ? dataNula : parse(parse(dataInicioLimiteMaximo).setHours(0, 0, 0, 0));

    if (isEqual(data, dataNula) || data === undefined || data.toString() === 'Invalid Date') {
      return 'A data não pode ser nula.';
    }
    if (!isEqual(data, dataNula) && !isEqual(dataFim, dataNula) && isAfter(data, dataFim)) {
      return 'A data não pode ser maior que a data Fim Adesão.';
    }
    // if (indRegistroPossuiDependencias === 'S' && isAfter(data, dataInicioOriginal)) {
    //   return 'Este beneficiário já possui guias vinculadas.';
    // }

    if (titularidade === 'SERVIDOR') {
      if (isAfter(dataInicioLimiteMinimo, data)) {
        return 'A data início não pode ser menor que a data fim dos últimos cadastros.';
      }
      if (isAfter(data, dataInicioLimiteMaximo)) {
        return 'A data início não pode ser maior que as datas início dos dependentes.';
      }
    } else {
      if (isAfter(dataInicioLimiteMinimo, data)) {
        return 'A data início não pode ser menor que a data início do titular.';
      }
      // if (isAfter(data, dataInicioLimiteMaximo)) {
      //   return 'A data início não pode ser maior que a data fim do titular.';
      // }
    }
    return '';
  }

  async validarDataFim (data, dataInicio, titularidade, dataFimLimiteMaximo) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    dataFimLimiteMaximo = dataFimLimiteMaximo === null ? dataNula : parse(parse(dataFimLimiteMaximo).setHours(0, 0, 0, 0));

    if (!isEqual(data, dataNula) && isAfter(dataInicio, data)) {
      return 'A data não pode ser menor que a data Início Adesão.';
    }

    if (titularidade === 'SERVIDOR') {
      if (!isEqual(data, dataNula)) {
        if (!isEqual(dataFimLimiteMaximo, dataNula) && isAfter(data, dataFimLimiteMaximo)) {
          return 'A data fim não pode ser maior que as datas início dos outros cadastros.';
        }
      }
    }
    return '';
  }
  async consultarBeneficiarioInternado (carteira, dtaAtendimento) {
    let result = await this.getBeneficiarioApi().consultarBeneficiarioInternado(carteira, dtaAtendimento);
    return result;
  }

  async consultarTelefones (codServidor, seqDependenteRH) {
    let telefones = [];
    let result = await this.getBeneficiarioApi().consultarTelefones(codServidor, seqDependenteRH);
    result.map(res => {
      const { codTipoTelefone, desTipoTelefone, numDDD, numTelefone, txtObservacao } = res;
      telefones.push(Object.values({ numDDD, numTelefone, codTipoTelefone, desTipoTelefone, txtObservacao }));
    });
    return telefones || [];
  }
  async consultarHistoricos (codServidor, seqDependenteRH) {
    let historicos = [];
    let result = await this.getBeneficiarioApi().consultarHistoricos(codServidor, seqDependenteRH);
    result.map(res => {
      const { titularidade, dtaInicio, dtaFim } = res;
      historicos.push(Object.values({ titularidade, dtaInicio, dtaFim }));
    });
    return historicos || [];
  }
  async consultarEmails (codServidor, seqDependenteRH) {
    let emails = [];
    let result = await this.getBeneficiarioApi().consultarEmails(codServidor, seqDependenteRH);
    result.map(res => {
      const { idEmail, desEmail } = res;
      emails.push(Object.values({ idEmail, desEmail }));
    });
    return emails || [];
  }
  async consultarEnderecos (codServidor, seqDependenteRH) {
    let enderecos = [];
    let result = await this.getBeneficiarioApi().consultarEnderecos(codServidor, seqDependenteRH);
    result.map(res => {
      const { idEndereco, desEndereco, bairro, cidade, siglaUF, cep, numero, complemento } = res;
      enderecos.push(Object.values({ idEndereco, desEndereco, bairro, cidade, siglaUF, cep, numero, complemento }));
    });
    return enderecos || [];
  }
  async consultarRequisitado (codServidor, seqDependenteRH) {
    let requisitado = [];
    let result = await this.getBeneficiarioApi().consultarRequisitado(codServidor, seqDependenteRH);
    result.map(res => {
      const { codServidor, dtaInicio, dtaFim, carreira, orgaoExterno, txtObservacao } = res;
      requisitado.push(Object.values({ codServidor, dtaInicio, dtaFim, carreira, orgaoExterno, txtObservacao }));
    });
    return requisitado || [];
  }
  async consultarRequisitadoHistorico (codServidor, seqDependenteRH) {
    let requisitado = [];
    let result = await this.getBeneficiarioApi().consultarRequisitadoHistorico(codServidor, seqDependenteRH);
    result.map(res => {
      const { divisao, dtaInicio, dtaFim, situacao } = res;
      requisitado.push(Object.values({ divisao, dtaInicio, dtaFim, situacao }));
    });
    return requisitado || [];
  }
}
export default BeneficiarioService;
